import { object , string, number, boolean, array, mixed, InferType } from 'yup';

export enum Portal {
  eClaimLink = 'ECLAIMLINK',
  Shafafiya = 'SHAFAFIYA',
  Riayati = 'RIAYATI',
}

export const branchRegistrationWorkflowDtoSchema = object({
  id: string().required(),
  createdAt: string().required(),
  updatedAt: string().required(),
  portal: mixed<Portal>().oneOf(Object.values(Portal)).required(),
  login: string().required(),
  areCredentialsValid: boolean().required(),
  foundProviders: array().of(string().required()).nullable(),
  excludedProviders: array().of(string().required()).nullable(),
  upsertedProviders: array().of(string().required()).nullable(),
  isCompleted: boolean().required(),
  error: string().nullable(),
  isOwn: boolean().required(),
});
export type BranchRegistrationWorkflowDto = InferType<typeof branchRegistrationWorkflowDtoSchema>;

export const onboardingDtoSchema = object({
  id: string().required(),
  createdAt: string().required(),
  updatedAt: string().required(),
  organizationId: number().required(),
  lastAdminActionAt: string().required(),
  isAdminFlowCompleted: boolean().required(),
  sharedFlowId: string().nullable(),
  sharedFlowExpiresAt: string().nullable(),
  branchRegistrationWorkflowIds: array().of(string().required()).required(),
  branchRegistrationWorkflows: array().of(branchRegistrationWorkflowDtoSchema).required(),
  branchesBelongingToOtherOrganizations: array().of(string().required()).required(),
});
export type OnboardingDto = InferType<typeof onboardingDtoSchema>;

export const createBranchRegistrationWorkflowDtoSchema = object({
  secret: string().nullable(),
  portal: mixed<Portal>().oneOf(Object.values(Portal)).required(),
  login: string().required(),
  password: string().required(),
});
export type CreateBranchRegistrationWorkflowDto = InferType<typeof createBranchRegistrationWorkflowDtoSchema>;

export const updateBranchRegistrationWorkflowCredentialsDtoSchema = object({
  secret: string().nullable(),
  id: string().required(),
  portal: mixed<Portal>().oneOf(Object.values(Portal)).required(),
  login: string().required(),
  password: string().required(),
});
export type UpdateBranchRegistrationWorkflowCredentialsDto = InferType<typeof updateBranchRegistrationWorkflowCredentialsDtoSchema>;

export const excludeBranchesFromRegistrationWorkflowDtoSchema = object({
  secret: string().nullable(),
  id: string().required(),
  branches: array().of(string().required()).required(),
});
export type ExcludeBranchesFromRegistrationWorkflowDto = InferType<typeof excludeBranchesFromRegistrationWorkflowDtoSchema>;

export const includeBranchesToRegistrationWorkflowDtoSchema = object({
  secret: string().nullable(),
  id: string().required(),
  branches: array().of(string().required()).required(),
});
export type IncludeBranchesToRegistrationWorkflowDto = InferType<typeof includeBranchesToRegistrationWorkflowDtoSchema>;

export const deleteBranchRegistrationWorkflowDtoSchema = object({
  secret: string().nullable(),
  id: string().required(),
});
export type DeleteBranchRegistrationWorkflowDto = InferType<typeof deleteBranchRegistrationWorkflowDtoSchema>;

export const completeOwnFlowDtoSchema = object({
  secret: string().required(),
});
export type CompleteOwnFlowDto = InferType<typeof completeOwnFlowDtoSchema>;
